module.exports = __webpack_public_path__ + "fonts/icomoon.915c267a.eot";